(() => {
  if (customElements.get('plumo-reviews')) return;
  class PlumoReviews extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.track = this.querySelector('[data-review-track]');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.status = this.querySelector('[data-review-status]');
      if (!this.track) return;
      const opts = {signal: this.controller.signal};
      this.prev?.addEventListener('click', () => this.move(-1), opts);
      this.next?.addEventListener('click', () => this.move(1), opts);
      this.track.addEventListener('scroll', () => this.update(), {...opts, passive: true});
      this.track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1); }
      }, opts);
      document.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('[data-review-card]');
        if (card && this.contains(card)) this.track.scrollTo({left: card.offsetLeft - this.track.offsetLeft, behavior: 'instant'});
      }, opts);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      requestAnimationFrame(() => this.update());
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    move(direction) {
      const card = this.track.querySelector('[data-review-card]');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 18;
      this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      if (this.prev) this.prev.disabled = t.scrollLeft <= 3;
      if (this.next) this.next.disabled = t.scrollLeft >= max - 3;
      const cards = [...t.querySelectorAll('[data-review-card]')];
      const box = t.getBoundingClientRect();
      const visible = cards.map((card, i) => ({i, b: card.getBoundingClientRect()})).filter(({b}) => b.left < box.right - 20 && b.right > box.left + 20);
      if (this.status && visible.length) {
        const first = visible[0].i + 1, last = visible.at(-1).i + 1;
        this.status.textContent = `${first === last ? first : first + '–' + last} / ${cards.length}`;
      }
    }
  }
  customElements.define('plumo-reviews', PlumoReviews);
})();
